import './ToolSizeControl.css'

const MIN = 2
const MAX = 60
const STEP = 2

/** הגדלה/הקטנה של גודל הכלי — לכל כלי (מברשת, עיפרון, מרקר, מריחה, נצנצים) */
export function ToolSizeControl({ value, onChange }) {
  const n = Math.max(MIN, Math.min(MAX, Number(value) || MIN))
  const decrease = () => onChange(Math.max(MIN, n - STEP))
  const increase = () => onChange(Math.min(MAX, n + STEP))
  return (
    <div className="tool-size-control">
      <span className="tool-size-label">גודל</span>
      <div className="tool-size-buttons">
        <button type="button" className="tool-size-btn" onClick={decrease} aria-label="הקטן" disabled={n <= MIN}>−</button>
        <span className="tool-size-value" aria-live="polite">{n}</span>
        <button type="button" className="tool-size-btn" onClick={increase} aria-label="הגדל" disabled={n >= MAX}>+</button>
      </div>
    </div>
  )
}
